"use client";
import { jsx as e, jsxs as B } from "react/jsx-runtime";
import { cva as x } from "class-variance-authority";
import { forwardRef as k, useState as N } from "react";
import { twMerge as T } from "tailwind-merge";
import { cn as l } from "./index.es14.js";
import { Text as v } from "./index.es4.js";
const y = x(
  `
    px-6
    rounded-sm
    focus-visible:outline-2
    focus-visible:outline-blue-600
    focus-visible:outline-offset-2
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), m = x("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), I = k(
  ({
    children: n,
    variant: t,
    className: p = "",
    size: o = "default",
    disabled: r = !1,
    href: a,
    iconPrefix: s,
    iconSuffix: u,
    ...c
  }, h) => {
    const f = o === "large" ? "base" : "sm", [w, g] = N(!1), d = (F) => {
      F.currentTarget.matches(":focus-visible") && g(!0);
    }, b = () => g(!1);
    let i;
    return a && !r ? i = /* @__PURE__ */ e(
      "a",
      {
        ...c,
        ref: h,
        className: l(y({ variant: t, size: o, disabled: r, isLink: !0 })),
        href: a,
        onFocus: d,
        onBlur: b,
        children: /* @__PURE__ */ e(v, { asChild: !0, fontSize: f, children: /* @__PURE__ */ e("span", { children: n }) })
      }
    ) : i = /* @__PURE__ */ B(
      "button",
      {
        ...c,
        ref: h,
        className: l(y({ variant: t, size: o, disabled: r })),
        disabled: r,
        onFocus: d,
        onBlur: b,
        children: [
          s && /* @__PURE__ */ e("div", { className: l(m({ variant: t, disabled: r })), children: s }),
          /* @__PURE__ */ e(v, { asChild: !0, fontSize: f, children: /* @__PURE__ */ e("span", { children: n }) }),
          u && /* @__PURE__ */ e("div", { className: l(m({ variant: t, disabled: r })), children: u })
        ]
      }
    ), /* @__PURE__ */ e(
      "div",
      {
        className: T(
          "inline-block rounded-sm w-auto",
          w && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-4",
          p
        ),
        children: i
      }
    );
  }
);
export {
  I as Button
};
